type Language = 'en' | 'es' | 'ru' | 'hy' | 'de' | 'fr' | 'it'

type Translations = {
    [key in Language]: {
        buttonText: string
    }
}

export const translations: Translations = {
    en: { buttonText: 'Create account' },
    es: { buttonText: 'Crear cuenta' },
    ru: { buttonText: 'Создать аккаунт' },
    hy: { buttonText: 'Ստեղծել հաշիվ' },
    de: { buttonText: 'Konto erstellen' },
    fr: { buttonText: 'Créer un compte' },
    it: { buttonText: 'Crea account' },
}

export const getTranslation = (language: string) =>
    translations[language as Language] || translations.en
